import {
  RegistryGlobalSummaryAny,
  RegistryGlobalSummaryV2,
  RegistryGlobalSummaryLegacy,
  FlexStringList,
} from '../../../types';

// v2 的判别字段（顶层独有键）。命中任一即认为是新版结构。
const V2_MARKER_KEYS = ['basic_info', 'plot_stages', 'final_logline', 'character_relationships'];

// 旧版（legacy）的判别字段。
const LEGACY_MARKER_KEYS = ['world_setting', 'total_acts', 'plot_driver_mode'];

/**
 * 探测世界观 JSON 是新版（v2 嵌套）还是旧版（legacy 扁平 8 字段）。
 * 后端是透传代理，不附带 format 字段，故在前端按字段探测。
 */
export function isGlobalV2(summary: RegistryGlobalSummaryAny | null | undefined): summary is RegistryGlobalSummaryV2 {
  if (!summary || typeof summary !== 'object') return false;
  const record = summary as Record<string, unknown>;
  const hasV2Marker = V2_MARKER_KEYS.some(key => key in record);
  if (!hasV2Marker) return false;
  // legacy 显式信号优先：含 legacy 标记且无 basic_info 时仍视为 legacy。
  const hasBasicInfo = 'basic_info' in record;
  const hasLegacyMarker = LEGACY_MARKER_KEYS.some(key => key in record);
  if (!hasBasicInfo && hasLegacyMarker) return false;
  return true;
}

/**
 * 容错地把 FlexStringList（可能是 string[] 或单个 string）归一为字符串数组。
 * 过滤掉空白项。
 */
export function toStringList(value: FlexStringList | undefined | null): string[] {
  if (value === undefined || value === null) return [];
  const items = Array.isArray(value) ? value : [value];
  return items
    .map(item => (typeof item === 'string' ? item.trim() : String(item ?? '').trim()))
    .filter(item => item !== '');
}

/** 判断一个值是否为「有内容」（非空字符串 / 非空数组 / 数字）。 */
export function hasValue(value: unknown): boolean {
  if (value === undefined || value === null) return false;
  if (typeof value === 'string') return value.trim() !== '';
  if (Array.isArray(value)) return value.length > 0;
  return true;
}

export type { RegistryGlobalSummaryLegacy };
